var AddedSportsModifier = /** @class */ (function () {
    function AddedSportsModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedSportsModifier.prototype.modify = function (content) {
        if (content.sports === undefined || content.sports.add === undefined) {
            return;
        }
        var sports = content.sports.add;
        for (var i = 0; i < sports.length; i++) {
            var sport = sports[i];
            var key = this._modelKeyRepository.addSport(sport.id);
            sports[i] = Object.assign({
                name: sport.n,
                priority: sport.p,
                eventCount: sport.ec
            }, key);
        }
    };
    return AddedSportsModifier;
}());
export default AddedSportsModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedSportsModifier.js